<template>
  <v-row align="center" justify="center">
    <div
      class="v-responsive"
      style="width: 839px; height: 472px;"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <div class="v-responsive__sizer" style="padding-bottom: 100%;"></div>
      <div class="v-image__image">
        <iframe id="ytplayer" type="text/html" width="839" height="472" :src="embedUrl" frameborder="0" />
      </div>
      <div v-if="hover" class="v-responsive__content">
        <v-row class="fill-height ma-0 darken" align="center" justify="center">
          <div class="">
            <v-btn color="gray" @click="startUploadImage">Edytuj</v-btn>
          </div>
        </v-row>
      </div>
    </div>
    <YouTubeUpload :show="showUpload" @close="showUpload = false" @uploaded="uploadImage" />
  </v-row>
</template>

<script>
import YouTubeUpload from '@/components/shared/YouTubeUpload.vue';

export default {
  components: {
    YouTubeUpload
  },
  props: {
    lesson: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      hover: false,
      showUpload: false,
      uploadLink: this.lesson.url
    };
  },
  computed: {
    youtubeUrl() {
      if (!this.uploadLink) {
        return '';
      }

      return this.uploadLink;
    },
    urlEnd() {
      if (!this.youtubeUrl) {
        return '';
      }

      if (!this.youtubeUrl.startsWith('https://youtu.be')) {
        const queryParams = new URLSearchParams(this.youtubeUrl.split('?')[1]);
        return `${queryParams.get('v')}${queryParams.get('t') ? '?start=' + queryParams.get('t') : ''}`;
      } else {
        let urlEnd = this.youtubeUrl.split('.be/')[1];
        const splittedPath = urlEnd.split('?');
        urlEnd = splittedPath[0];
        const queryParams = new URLSearchParams(splittedPath[1]);
        return `${urlEnd}${queryParams.get('t') ? '?start=' + queryParams.get('t') : ''}`;
      }
    },
    embedUrl() {
      if (!this.youtubeUrl) {
        return '';
      }

      return `https://www.youtube.com/embed/${this.urlEnd}`;
    }
  },
  watch: {
    showUpload(val) {
      if (val) {
        this.$emit('disableOutsideClick');
      } else {
        this.$emit('enableOutsideClick');
      }
    }
  },
  methods: {
    startUploadImage() {
      this.showUpload = true;
    },
    uploadImage(ev) {
      this.uploadLink = ev.url;
      this.$emit('change', { type: this.lesson.type, value: this.uploadLink });
    }
  }
};
</script>

<style lang="scss" scoped>
.darken {
  background: rgba(0, 0, 0, 0.5);
}
</style>
